import React, { useState } from "react";
import { dateFormatter, getAttendeePhotoUrl } from "../../../utils/Helper";
import { DEFAULT_PROFILE_IMAGE } from "../../../utils/brandAssets";
import GalleryModal from "../../Common/Modal/GalleryModal";

const getStatusMeta = (details) => {
  if (details?.cancelRequestStatus === "refunded") {
    return { label: "Cancelled", className: "is-cancelled" };
  }

  const status = String(details?.status || "")
    .trim()
    .toLowerCase();

  if (!status) {
    return { label: "—", className: "is-neutral" };
  }

  if (status === "check-in" || status === "active" || status === "valid") {
    return {
      label: status === "check-in" ? "Checked in" : status,
      className: "is-positive",
    };
  }

  if (status === "check-out") {
    return { label: "Checked out", className: "is-checkout" };
  }

  if (status === "not-valid" || status === "cancelled" || status === "expired") {
    return { label: status.replace("-", " "), className: "is-cancelled" };
  }

  return { label: status, className: "is-neutral" };
};

const AttendeeProfileCard = ({ details }) => {
  const [isOpen, setIsOpen] = useState(false);
  const profileSrc = getAttendeePhotoUrl(details?.photo);
  const statusMeta = getStatusMeta(details);
  const hasPhoto = Boolean(details?.photo);

  return (
    <section className="event-attendee-detail-card" aria-label="Attendee profile">
      <div className="event-attendee-detail-card-top">
        <h2 className="event-attendee-detail-name">{details?.name || "—"}</h2>
        <span
          className={`event-attendee-detail-status-badge ${statusMeta.className}`}
        >
          {statusMeta.label}
        </span>
      </div>

      <div className="event-attendee-detail-card-body">
        <button
          type="button"
          className="event-attendee-detail-profile-btn"
          onClick={() => hasPhoto && setIsOpen(true)}
          aria-label="View attendee photo"
        >
          <img
            className="event-attendee-detail-profile"
            src={profileSrc}
            alt={details?.name || "Attendee"}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = DEFAULT_PROFILE_IMAGE;
            }}
          />
        </button>

        <dl className="event-attendee-detail-meta">
          <div className="event-attendee-detail-meta-item">
            <dt>Email</dt>
            <dd>{details?.email || "—"}</dd>
          </div>
          <div className="event-attendee-detail-meta-item">
            <dt>Phone</dt>
            <dd>{details?.mobile || "—"}</dd>
          </div>
          <div className="event-attendee-detail-meta-item">
            <dt>Date of birth</dt>
            <dd>{details?.dob ? dateFormatter(details.dob) : "—"}</dd>
          </div>
          <div className="event-attendee-detail-meta-item">
            <dt>Band ID</dt>
            <dd>{details?.bandId || "—"}</dd>
          </div>
        </dl>
      </div>

      {hasPhoto && (
        <GalleryModal
          filesData={
            Array.isArray(details.photo) ? details.photo : [details.photo]
          }
          Open={isOpen}
          Index="0"
          onClose={() => setIsOpen(false)}
        />
      )}
    </section>
  );
};

export default AttendeeProfileCard;
